import MUIButton, {ButtonProps} from '@mui/material/Button';
import Link from '@mui/material/Link';
import React, {memo} from 'react';
import {useTranslation} from 'react-i18next';

import {getProductUrl} from '../../interfaces/products';
import {PRODUCTS} from '../../interfaces/products/products.enum';
import {LOCALES} from '../../utils/constants';
import {mapVilmerLanguage} from '../../utils/map-vilmer-language';

function AccountButton(props: ButtonProps<'a'>) {
  const {t, i18n} = useTranslation();

  const url = new URL(getProductUrl(PRODUCTS.Dashboard));
  const vilmerLng = mapVilmerLanguage(i18n.language as LOCALES);
  if (vilmerLng) {
    url.pathname = `/${vilmerLng}/account`;
  }

  return (
    <MUIButton
      component={Link}
      href={url.toString()}
      sx={{
        textAlign: 'center',
        maxWidth: '225px',
        width: 'inherit',
        textTransform: 'none',
        color: 'black',
      }}
      disableElevation
      {...props}
    >
      {t('navigation.account')}
    </MUIButton>
  );
}

export const AccountButtonComponent = memo(AccountButton);
